module.exports = __webpack_public_path__ + "static/media/voucher.11bb4da1.svg";